// extracted by mini-css-extract-plugin
export default {"container":"sD0MGT","background":"sB82_3"};